// @ts-nocheck
import { useEffect, useState } from 'react';

import { getLabelFallback } from '@utils/utils';
import { Checkbox } from '@mui/material';

import sha256 from 'crypto-js/sha256';
import md5 from 'crypto-js/md5';

import { useSelector, useDispatch } from 'react-redux';

import * as actions from '@redux-actions/';

import SuccessIconNoBackground from '@images/svg-icons/successIconNoBackground.svg';

interface Props {
    email: string;
    handleSubscriptions: any;
}

const EmailInbox = ({ email, handleSubscriptions }: Props) => {

    const dispatch = useDispatch();
    const userSettings = useSelector((state: RootState) => state.myProfile.userSettings);
    const userSubscriptionCorrect = useSelector((state: RootState) => state.myProfile.userSubscriptionCorrect);
    const userSubscriptionEmailChanged = useSelector((state: RootState) => state.myProfile.userSubscriptionEmailChanged);
    const [checked, setChecked] = useState(false);
    let userEmailSub;
    let userEmailUnsub;

    const clickOnCheckbox = () => {
        dispatch(actions.getUserSubscriptionCorrect(false));
        dispatch(actions.getUserSubscriptionPhoneChanged(false));
        dispatch(actions.getUserSubscriptionEmailChanged(true));
        dispatch(actions.getUserSubscriptionEmail(!checked));
        setChecked(!checked);
    };

    useEffect(() => {
        if(!!userSettings && !!userSettings.subscription) {
            setChecked(userSettings.subscription.isUserSubscribedByEmail);
        }
    }, [userSettings])

    return (
        <div className="content-container inbox-email">
            <div className="inbox-email-title">{getLabelFallback('INBOX_EMAIL_TITLE_LABEL')}</div>
            <div className="inbox-email-subtitle">{getLabelFallback('INBOX_EMAIL_SUBTITLE_LABEL')}</div>
            <div className="inbox-email-value">{email}</div>
            <div className="inbox-email-checkbox">
                <div className="inbox-email-checkbox-left">
                    <Checkbox
                        size="small"
                        inputProps={{
                            'aria-label': 'Email',
                        }}
                        checked={checked}
                        onChange={() => {
                            if (checked) {
                                userEmailSub = '0';
                                userEmailUnsub = '1';
                            } else {
                                userEmailSub = '1';
                                userEmailUnsub = '0';
                            }
                            if (email.toLowerCase().trim() == "") {
                                tealium_data2track.push({
                                    User_Email_MD5: '',
                                    User_Email_SHA256: '',
                                    Events_UserEmailSub: userEmailSub,
                                    Events_UserEmailUnsub: userEmailUnsub
                                });
                            } else {
                                tealium_data2track.push({
                                    User_Email_MD5: md5(email).toString(),
                                    User_Email_SHA256: sha256(email).toString(),
                                    Events_UserEmailSub: userEmailSub,
                                    Events_UserEmailUnsub: userEmailUnsub
                                });
                            }
                            clickOnCheckbox();
                        }}
                    />
                </div>
                <div className="inbox-email-checkbox-right">
                    <div className="inbox-email-checkbox-right-top">{getLabelFallback('INBOX_CHECKBOX_EMAIL_TITLE_LABEL')}</div>
                    <div 
                        className="inbox-email-checkbox-right-bottom" 
                        dangerouslySetInnerHTML={{ __html: getLabelFallback('INBOX_CHECKBOX_EMAIL_SUBTITLE_LABEL') }}
                    ></div>
                </div>
            </div>
            {userSubscriptionCorrect && userSubscriptionEmailChanged && (
                <div className='inbox-email-success'>
                    {checked && (
                        <div className="success-message">
                            <SuccessIconNoBackground />
                            <span className="secondary-message medium success bold">
                                {getLabelFallback(
                                    'SETTINGS_UPDATE_PASSWORD_FORM_SUCCESS_MESSAGE'
                                )}
                            </span>
                        </div>
                    )}
                    {!checked && (
                        <div className="success-message">
                            <SuccessIconNoBackground />
                            <span className="secondary-message medium success bold">
                                {getLabelFallback(
                                    'INBOX_REMOVE_SUCCESS_MESSAGE'
                                )}
                            </span>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
export default EmailInbox;
